<template>  
    <section class="my-news">
		<div v-html="detail.content" class="content-new"></div>
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
    import utils from '@/assets/jslibs/utils'
    import {getMessageDetail} from '@/api/personal'
    export default {
        name: 'news-detail',
		data(){
			return{
				detail:"",    //消息详情
				order_uuid:this.$route.query.order_uuid,
                content:""
			}
		},
        components: {
            CommonHeader,
        },
		
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
       
        created() {
			this.getMessageDetail()
        },
        
        mounted(){
            document.title = "消息详情"
            
        },
        methods: {
			async getMessageDetail(){
			    const { data, status } = await getMessageDetail(this.order_uuid);
			    if (status !== 200) return 
				this.detail=data;
			},
        }
    }
</script>
<style>
   .my-news .content-new img{width: 100%}
    
</style>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;;font-weight:400;background: #fff}
	.tabs{height: 44px;border-bottom: 1px solid #EEEEEE;padding: 0 68px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
	.tabs span{color:rgba(51,51,51,1);font-size: 16px;height: 44px;line-height: 44px;}
    .select-flag{color:rgba(65,132,244,1);border-bottom: 2px solid #4184F4;font-family:PingFangSC-Medium;font-weight:500;}
	.news-wrap{border-bottom: 1px solid #EEEEEE;padding: 11px 13px 14px 16px;}
	.text{font-family:PingFangSC-Medium;font-weight:500;color:rgba(20,20,20,1);font-size: 14px}
	.time{color:rgba(153,153,153,1);font-size: 11px;float: right;}
	.name{color:rgba(153,153,153,1);font-size: 13px;margin-top: 4px}
    .content-new{.w(375);margin: 0 auto;overflow-x: hidden}
</style>
